export const orgData = {
  tableColumnTitles: ['Licene plate', 'Name', 'Email'],
  userFields: {
    email: {
      key: 'email',
      label: 'Email Address',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Provide your email' },
      email: { value: true, err: 'Provide a valid email' }
    },
    name: {
      key: 'name',
      label: 'Name',
      type: 'input_text',
      placement: 'full',
      required: { value: true, err: 'Provide your name' },
    },
    phone: {
      key: 'phone',
      label: 'Phone',
      type: 'input_text',
      placement: 'right',
      required: { value: false, err: 'Provide phone number' },
      phone: { value: true, err: 'Provide a valid phone' },
    },
    lp: {
      key: 'lp',
      label: 'Vehicle Number',
      type: 'input_text',
      placement: 'full',
      required: { value: false, err: 'Provide vechicle number' },
    },
  },
  popOverFields: [
    {
      key: 'delete',
      title: 'Delete'
    }
  ]
}


// WEBPACK FOOTER //
// ./src/screens/GuestUsersDetails/Data.js